// extracted by mini-css-extract-plugin
export default {"title":"navigation_title__Z5iMp","dot":"navigation_dot__VQh6D","container":"navigation_container__bsBW2","space":"navigation_space__QDjL9","link":"navigation_link__+58QL"};